import React from "react";
import PropTypes from "prop-types";
import { footerUrls } from "../../../constants";

function FooterNav(props) {
  return (
    <div className="nw-footer-nav-container">
      <a
        id="nw-footer-nav-links-whoweare"
        className="nw-footer-nav-links"
        href={props.store.basePath + footerUrls.whoweare}
      >
        WHO WE ARE
      </a>
      <a
        id="nw-footer-nav-links-customercare"
        className="nw-footer-nav-links"
        href={props.store.basePath + footerUrls.customercare}
      >
        CUSTOMER CARE
      </a>
      <a
        id="nw-footer-nav-links-contactus"
        className="nw-footer-nav-links"
        href={props.store.basePath + footerUrls.contactus}
      >
        CONTACT US
      </a>
    </div>
  );
}

FooterNav.propTypes = {
  store: PropTypes.shape({
    basePath: PropTypes.string.isRequired,
  }).isRequired,
};

export default FooterNav;



// WEBPACK FOOTER //
// ./src/component/Footer/FooterNav/index.js